const kachingBlock = document.querySelector('.kaching-bundles__block.kaching-bundles__block--loaded');

if (kachingBlock) {
  applyChanges();
} else {
  document.addEventListener("kaching-bundles-block-loaded", (event) => {
    applyChanges();
  });
}

function applyChanges() {
  updateTimerBlock();
  insertImagesToBars();
  addSlashesToUnits();
}

function updateTimerBlock() {
  const timerEl = document.querySelector('.kaching-bundles__timer');

  const blockContainer = document.createElement('div');
  blockContainer.classList.add('kaching-custom-timer-block-container');

  const saveBlock = createTimerTextBlock('Save up to 45%');
  const shippingBlock = createTimerTextBlock('Free Shipping');

  blockContainer.appendChild(saveBlock);
  blockContainer.appendChild(shippingBlock);
  timerEl.appendChild(blockContainer);
}

function createTimerTextBlock(text) {
  const containerEl = document.createElement('div');
  containerEl.classList.add('kaching-custom-timer-block');

  const iconEl = document.createElement('img');
  iconEl.src = 'https://cdn.shopify.com/s/files/1/0803/4988/8805/files/check.svg?v=1791325551';

  const textEl = document.createElement('span');
  textEl.textContent = text;

  containerEl.appendChild(iconEl);
  containerEl.appendChild(textEl);

  return containerEl;
}

function insertImagesToBars() {
  const container = document.querySelector('.kaching-bundles__bars');

  for (let i = 0; i < container.children.length; i++) {
    const barEl = container.children[i];
    const mainEl = barEl.querySelector('.kaching-bundles__bar-main');
    const radioEl = mainEl.querySelector('.kaching-bundles__bar-radio');

    const image = document.createElement('img');
    image.src = getImageByIndex(i);
    image.classList.add('kaching-custom-bar-image');
    radioEl.after(image);

    if (i === 1) {
      const contanerEl = barEl.querySelector('.kaching-bundles__bar-container');
      const mobilePlaceholderEl = document.createElement('div');
      mobilePlaceholderEl.classList.add('kaching-mobile-bar-placeholder');
      contanerEl.appendChild(mobilePlaceholderEl);
    }
  }
}

function getImageByIndex(index) {
  switch (index) {
    case 0:
      return 'https://cdn.shopify.com/s/files/1/0803/4988/8805/files/go-hammock-1-pack.png?v=1791333827';
    case 1:
      return 'https://cdn.shopify.com/s/files/1/0803/4988/8805/files/go-hammock-2-pack.png?v=1791333827';
    case 2:
      return 'https://cdn.shopify.com/s/files/1/0803/4988/8805/files/go-hammock-3-pack.png?v=1791333827';
  }
  return '';
}

function addSlashesToUnits() {
  const perUnitEls = document.querySelectorAll('.kaching-bundles__bar-price__unit-label');
  perUnitEls.forEach(perUnitEl => {
    perUnitEl.textContent = '/' + perUnitEl.textContent;
  });
}

class GoPillowUpsell extends HTMLElement {
  #kachingWidget;
  #qtyEls;
  #titleEl;
  #isActive = false;
  #upsellVariantId = 52739378086181;
  #quantity = 2;

  set quantity(value) {
    this.#quantity = value;
    this.#qtyEls.forEach(qtyEl => {
      if (this.#quantity === 1) {
        qtyEl.style.display = 'none';
      } else {
        qtyEl.style.display = '';
      }
      qtyEl.textContent = this.#quantity;
    });
    this.updatePrices();
    this.updateTitle();
  }

  constructor() {
    super();

    const kachingBlock = document.querySelector('.kaching-bundles__block.kaching-bundles__block--loaded');

    if (kachingBlock) {
      this.init();
    } else {
      document.addEventListener("kaching-bundles-block-loaded", (event) => {
        this.init();
      });
    }
  }

  init() {
    this.#kachingWidget = document.querySelector('kaching-bundles-block');
    this.#kachingWidget.addEventListener('items-changed', this.onKachingItemsChanged.bind(this));
    this.#qtyEls = this.querySelectorAll('.go-pillow-product-qty');
    this.#titleEl = this.querySelector('.go-pillow-toggle > span');

    const checkbox = this.querySelector('input[type="checkbox"]');
    checkbox.addEventListener('change', (event) => this.#isActive = checkbox.checked);

    const productForm = document.querySelector('form.main-product-form');
    productForm.addEventListener('submit', this.onProductFormSubmit.bind(this));
  }

  onKachingItemsChanged() {
    const items = this.#kachingWidget.items();
    if (items.length) {
      this.quantity = items[0].quantity;
    }
  }

  updatePrices() {
    let totalPrice = 0, totalComparePrice = 0;

    const productEls = this.querySelectorAll('.go-pillow-product');
    productEls.forEach(productEl => {
      const price = Number(productEl.dataset.price) * this.#quantity;
      const comparePrice = Number(productEl.dataset.comparePrice) * this.#quantity;

      const priceEl = productEl.querySelector('.go-pillow-product__pricing strong');
      const comparePriceEl = productEl.querySelector('.go-pillow-product__pricing s');

      priceEl.textContent = `$${price}`;
      comparePriceEl.textContent = `$${comparePrice}`;

      totalPrice += price;
      totalComparePrice += comparePrice;

    });

    const totalPriceEl = this.querySelector('.go-pillow-pricing strong');
    const totalComparePriceEl = this.querySelector('.go-pillow-pricing s');

    totalPriceEl.textContent = `$${totalPrice}`;
    totalComparePriceEl.textContent = `$${totalComparePrice}`;
  }

  updateTitle() {
    switch (this.#quantity) {
      case 1:
        this.#titleEl.textContent = 'GO Pillow & Under Net Offer!';
        break;
      case 2:
        this.#titleEl.textContent = 'GO Pillow & Under Net 2 Pack Offer!';
        break;
      case 3:
        this.#titleEl.textContent = 'GO Pillow & Under Net 3 Pack Offer!';
        break;
    }
  }

  onProductFormSubmit() {
    setTimeout(() => {
      if (!this.#isActive) {
        return;
      }

      const items = [{ id: this.#upsellVariantId, quantity: this.#quantity }];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items,
        })
      }).then((response) => response.json())
        .catch(error => console.log('error', error));
    }, 1000);
  }
}

if (!customElements.get('go-pillow-upsell')) {
  customElements.define('go-pillow-upsell', GoPillowUpsell);
}
